import React from 'react';

import ActionCard, { ActionCardVariant } from 'components/Common/Cards/ActionCard';
import { AvailableShift } from 'components/FinancialCheckup/FinancialDashboard/AvailableShiftsSection/useAvailableShifts';

import ShiftCard from './ShiftCard';

interface ShiftsListProps {
  shifts: AvailableShift[];
}

const ShiftsList: React.FC<ShiftsListProps> = ({ shifts }) => (
  <ActionCard variant={ActionCardVariant.White}>
    {shifts.map((shift) => (
      <ShiftCard key={shift.id} shift={shift} />
    ))}
  </ActionCard>
);

export default ShiftsList;
